import { toast } from 'react-toastify';

const dismissAll = () => {
  return toast.dismiss();
};

export default dismissAll;
